import { setElementAttrs } from '@/mixins/element-attrs';

function wrapString(stringArray, tag, attributes = false) {
	const elements = [];

	stringArray.forEach((string, index) => {
		const element = document.createElement(tag);

		setElementAttrs(element, {
			innerText: string,
		});

		if (attributes) {
			setElementAttrs(element, attributes);
		}

		elements[index] = element;
	});

	return elements;
}

function wrapLines(text, tag, attributes = false) {
	const trimmedText = text.replace(/\n|\r/g, "");
	const lines = trimmedText.split("<br />");
	return wrapString(lines, tag, attributes);
}

function wrapWords(text, tag, attributes = false) {
	const words = text.split(" ");
	return wrapString(words, tag, attributes);
}

function wrapCharacters(text, tag, attributes = false) {
	const letters = text.split("");
	return wrapString(letters, tag, attributes);
}

function elementsToStrings(elementsArray) {
	const strings = [];

	elementsArray.forEach((element, index) => {
		strings[index] = element.outerHTML;
	});

	return strings.join("");
}

function wrapCharactersToString(text, tag, attributes = false) {
	const characters = wrapCharacters(text, tag, attributes);
	return elementsToStrings(characters);
}

export { wrapLines };
export { wrapWords };
export { wrapCharacters };
export { elementsToStrings };
export { wrapCharactersToString };
export default wrapCharactersToString;



// WEBPACK FOOTER //
// ./src/mixins/text-wrapper.js